import FlybitsSlot from "../components/flybits-slot";
import FlybitsOverlay from "../components/flybits-overlay";
import FlybitsLoading from "../components/flybits-loading";
import FlybitsError from "../components/flybits-error";
import ActionLink from "../models/actionLink";
import OutletManager from "./outletManager";
import cfg from '../../package.json';

/**
 * Base CustomElement with reactive properties and internal state.
 * @external LitElement
 * @see {@link https://lit.dev/docs/api/LitElement/|LitElement Definition}
 * @see {@link https://lit.dev/|Lit library}
 */

/**
 * Native DOM element event with custom data payloads
 * @external CustomEvent
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent|CustomEvent Definition}
 */

/**
 * Native DOM element
 * @external HTMLElement
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement|HTMLElement Definition}
 */

/**
 * Encapsulated DOM tree within a native Custom Element.
 * @external ShadowDOM
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_shadow_DOM|Using Shadow DOM}
 */

/**
 * ES6 Promise object.
 * @external Promise
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise|Promise API}
 * @see {@link http://www.ecma-international.org/ecma-262/6.0/#sec-promise-objects|Promise spec}
 */

/**
 * Flybits Content Instance
 * @external FlybitsContent
 * @see {@link https://js.flybits.app/docs/sdk/latest/Flybits.Content.html|Flybits Content Instance Definition}
 */

/**
 * @member {string} VERSION Flightkit library semantic version string.
 * @memberof Flightkit
 * @static
 * @constant
 */
const VERSION = cfg.version;

/**
 * This is the root namespace for the Flighkit SDK.  This is accessible from the `window` object.
 * @namespace
 */
const Flightkit = {
  FlybitsSlot: FlybitsSlot,
  outlet: OutletManager,
  FlybitsOverlay: FlybitsOverlay,
  ActionLink: ActionLink,
  FlybitsLoading: FlybitsLoading,
  FlybitsError: FlybitsError,
  VERSION: VERSION
};

if(typeof window === 'object' && typeof window.Flightkit !== 'object'){
  window.Flightkit = Flightkit;
}

/**
 * @module flightkit
 * @desc This is the main Flightkit module which exports named values so you may import them as follows:
 * ```
 * import { FlybitsSlot, FlybitsOverlay, FlybitsLoading, FlybitsError, ActionLink, OutletManager } from 'flightkit'
 * ```
 */
export {
  FlybitsSlot,
  FlybitsOverlay,
  FlybitsLoading,
  FlybitsError,
  ActionLink,
  OutletManager,
  VERSION
}